import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5.19 1.72C4.591 1.013 3.45.8 2.73 1.58c-.42.454-.85 1.046-1.076 1.724-.294.881-.121 1.968.467 3.176.592 1.215 1.634 2.615 3.19 4.17l.707-.707C4.509 8.435 3.548 7.124 3.02 6.042c-.531-1.09-.594-1.89-.417-2.422.164-.494.494-.965.862-1.361.222-.24.661-.248.96.106L5.63 3.788c.224.265.26.64.092.943l-.357.643c-.316.57-.315 1.288.087 1.847.335.465.85 1.121 1.508 1.78l.708-.707c-.61-.61-1.09-1.222-1.404-1.658a.721.721 0 01-.025-.776l.358-.643c.37-.667.289-1.493-.204-2.075L5.19 1.72z",
    fill: "#000",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M14.242 10.772c.705.597.918 1.738.14 2.458-.455.421-1.047.85-1.724 1.077-.882.294-1.969.121-3.176-.467-1.216-.592-2.616-1.634-4.171-3.19l.707-.707c1.508 1.509 2.82 2.47 3.902 2.998 1.09.531 1.89.595 2.421.417.494-.164.965-.494 1.362-.862.24-.222.247-.661-.107-.96l-1.423-1.205a.833.833 0 00-.943-.092l-.643.357c-.57.316-1.288.315-1.846-.087A14.717 14.717 0 016.96 9l.707-.707c.61.61 1.221 1.09 1.657 1.403.215.155.513.171.777.025l.642-.357a1.833 1.833 0 012.075.203l1.423 1.204z",
    fill: "#000",
    fillOpacity: 0.87
  }));
}
export default SvgComponent;